import Big, { BigSource, RoundingMode } from 'big.js'

export const amountToWei = (
  amount: BigSource = '0',
  decimal: number = 18,
): Big => {
  return new Big(new Big(amount).times(new Big(10).pow(decimal)).toFixed(0))
}
export const amountFromWei = (
  amount: BigSource = '0',
  decimal: number = 18,
): Big => {
  return new Big(amount).div(new Big(10).pow(decimal))
}

export const toFixed = (
  amount: BigSource,
  toFixed = 0,
  rm?: RoundingMode,
): Big => {
  return new Big(new Big(amount).toFixed(toFixed, rm))
}

export const toFixedStr = (
  amount: BigSource,
  toFixedStr = 0,
  rm?: RoundingMode,
): string => {
  return toFixed(amount, toFixedStr, rm).toString()
}

export const bsToString = (amount: BigSource) => {
  //BigSource to string for contract methods
  return new Big(amount).toFixed(0)
}
